import styled from 'styled-components'

export const AccountSidePanelContainer = styled.aside`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 300px;
  background-color: #ffffff;
  height: 30%;
  padding: 16px;
  border-radius: 16px;
`

export const LogoutButton = styled.button`
  background: #fff;
  border: none;
  color: #898483;
  text-align: left;

  cursor: pointer;
  transition: filter 0.3s;
  font-size: 1.25rem;
  font-weight: 600;
  :hover {
    color: #02b0bb;
  }
`

export const LogoutButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 5px;

  :hover {
    color: #02b0bb;
  }
`
